// react-quill-new hands onChange quill.getSemanticHTML(), which writes every typed
// space as &nbsp;. A paragraph of non-breaking spaces cannot wrap, so it overflows
// the fixed-width email frame (MWA-409). Quill only emits the &nbsp; entity for a
// U+0020 (a real U+00A0 comes out as the character), so turning the entity back
// into a space is lossless; the editor's own value must stay as Quill produced it
// or react-quill-new re-converts the contents on every keystroke.

const BLOCK_TAGS = 'p|li|h[1-6]|blockquote|pre|div|td|th'

// Leading and trailing spaces of a block are kept as &nbsp; because HTML drops them.
const SPACE_RUN = new RegExp(
  `(<(?:${BLOCK_TAGS})(?:\\s[^>]*)?>|<br\\s*/?>)?((?:&nbsp;)+)(</(?:${BLOCK_TAGS})>)?`,
  'gi'
)

export function quillHtmlToEmailHtml(html: string): string {
  return html.replace(SPACE_RUN, (_match, open: string | undefined, run: string, close: string | undefined) => {
    const count = run.length / '&nbsp;'.length
    let spaces = ''
    for (let i = 0; i < count; i++) {
      const isEdge = (i === 0 && open !== undefined) || (i === count - 1 && close !== undefined)
      // Alternating keeps a run of spaces visible while leaving a break opportunity.
      spaces += isEdge || i % 2 === 1 ? '&nbsp;' : ' '
    }
    return `${open ?? ''}${spaces}${close ?? ''}`
  })
}
